<template>
	<modal-dialog :visible="visible" @close="close">
		<template v-slot:header>Upload Data</template>
		<template v-slot:body>
			<form v-on:submit.prevent="onFormSubmit">
				<div class="mb-3">
					<label class="form-label">Investment</label>
					<drop-down :options="companies" :value="selectedCompanyId" v-on:option-selected="onCompanySelected"></drop-down>
					<span class="field-error" v-if="v$.selectedCompanyId.$error">{{ v$.selectedCompanyId.$errors[0].$message }}</span>
				</div>
				
				<div class="mb-3">
					<drop-zone ref="dropZone" class="drop-area" @filesDropped="onFilesDropped" @removeFile="onFileRemoved"></drop-zone>
					<span class="field-error" v-if="v$.selectedFile.$error">{{ v$.selectedFile.$errors[0].$message }}</span>
				</div>
				<div class="mb-3">
					<button class="btn btn-primary w-100" :class="{disabled: isUploadDisabled}">Upload File</button>
				</div>
			</form>
		</template>
	</modal-dialog>
</template>

<script type="text/javascript">

	import ModalDialog from "@/views/shared/ModalDialog";
	import DropZone from '@/views/shared/DropZone'
	import DropDown from '@/views/shared/DropDown'
	import useVuelidate from "@vuelidate/core";
	import {required} from "@vuelidate/validators";
	import {UploadsApi} from "@/api/uploads_api";

	export default {
		name: 'DataCollectionUploadModal',
		inheritAttrs: false,
		emits: ['close'],
		mixins: [],
		
		components: {
			ModalDialog,
			DropDown,
			DropZone
		},
		
		filters: {
		},
		
		provide: function() {
			return {
			}
		},
		
		inject: [],
		
		props: ['visible','companies'],

		setup() {
			return {
				v$: useVuelidate()
			}
		},

		validations () {
			return {
				selectedCompanyId: {required},
				selectedFile: {required}
			}
		},
		
		data() {
			return {
				companyId: null,
				companyName: null,
				selectedFile: null,
				fileValid: false,
				uploading: false
			}
		},

		computed: {
			selectedCompanyId() {
				return this.companyId
			},
			isUploadDisabled() {
				return this.selectedCompanyId == null || !this.selectedFile || !this.fileValid || this.uploading == true
			},
		},
		
		watch: {
			
		},
		
		created() {
		},
		
		mounted() {
		},
		
		methods: {
			close() {
				this.$emit('close');
			},

			onFilesDropped(event) {
				const file = event[0]
				this.selectedFile = file
				this.fileValid = false
				UploadsApi.validateUpload(file)
					.then(result => {
						this.fileValid = result.valid
						this.$refs.dropZone.validationComplete(result.valid, result.errors)
					})
					.catch(err => {
						console.error('Validation error', err)
						this.$refs.dropZone.validationComplete(false, [{ msg: 'Could not validate file. Please try again.' }])
					})
			},

			onFileRemoved() {
				this.selectedFile = null
				this.fileValid = false
			},

			onCompanySelected(optionId, optLabel) {
				this.companyId = optionId
				this.companyName = optLabel
			},

			async onFormSubmit() {
				this.v$.$validate()
				if (!this.v$.$error) {
					this.uploading = true
					UploadsApi.newFinancialsUpload({
						file: this.selectedFile,
						uploadType: 'financials',
						investmentId: this.companyId
					}).then(() => {
						this.$refs.dropZone.reset()
						document.location.reload()
					})
					.catch(err => {
						console.error('Error creating new financials upload', err)
					})
					.finally(() => {
						this.uploading = false
					})
				}
			}

		}
	}
</script>

<style lang="scss" scoped>
</style>